
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import EventBus from "@/mixins/event-bus";

export default {
    mixins: [alertMixins],
    data() {
        return {
            maxPrice: 1000000000,
            maxPriceErrorMsg: ''
        }
    },
    methods: {
        returnNumber(price) {
            if (!util.isEmpty(price)) {
                var regex = /[^0-9]/g;				// 숫자가 아닌 문자열을 선택하는 정규식
                price = String(price).replace(regex, "");
                return util.Number.returnNumber(price);
            } else {
                return 0;
            }
        },
        returnCommas(price) {
            if (!util.isEmpty(price)) {
                return util.Number.numFormat(price);
            } else {
                return 0;
            }
        },
        returnPrice(val) { // 소수점 자리 제외
            if (util.isEmpty(val) || isNaN(val)) {
                return 0
            }
            return Math.floor(val);
        },
        returnCoinString(data) { // 1000 단위만 k 변환
            let price = Number(data);
            if (0 <= price && price < 1000) {
                return price
            } else if (1000 <= price) {
                price = parseInt(price / 1000)
                return `${price}K`
            }
        },
        returnMaxItemString(data) { // 100부터 99+
            let item = Number(data);
            if (0 <= item && item < 100) {
                return item
            } else if (99 < item) {
                return `99+`
            }
        },

    }
}
